module.exports = __webpack_public_path__ + "static/media/outline-local_gas_station-24px.599e5bd9.svg";